import {createI18n} from 'vue-i18n'

const messages = {
    en: {
        message: {
            cart: 'cart',
            article: 'article',
            price: 'price CHF'
        }
    },
    de: {
        message: {
            cart: 'Warenkorb',
            article: 'Artikel',
            price: 'Preis CHF'
        }
    }
}

export const i18n = createI18n({
    legacy: false,
    locale: 'de', // set locale
    fallbackLocale: 'de', // set fallback locale
    messages, // set locale messages
})
